import React from 'react';
import {ArrowRightOutlined, CheckCircleOutlined, CloseOutlined, DeleteOutlined} from "@ant-design/icons";
import {IUser} from "../../../api/User/User.types";
import BrowserRouter, {BrowserRoutes} from "../../../routes/BrowserRouter";
import openDeleteUserModal from "./Users.table.deleteModal";
import Button from "../../common/Button/Button";

export const UsersTableConfig = (onDeleteUser: (userId: number) => void,) => {
    return [
        {
            title: 'Name', key: 'name',
            render: record => {
                return `${record.first_name} ${record.last_name}`
            }
        },
        {
            title: 'Email', dataIndex: 'email', key: 'email',
        },
        // {
        //     title: 'Role', dataIndex: 'role', key: 'role',
        //     render: role => {
        //         return role?.name || "No Role";
        //     }
        // },
        {
            title: 'Company', dataIndex: 'company', key: 'company',
            render: company => {
                return company?.name || "No Company";
            }
        },
        {
            title: 'Active', dataIndex: 'active', key: 'active',
            render: active => {
                return active ? <CheckCircleOutlined/> : <CloseOutlined style={{color:'red'}}/>;
            }
        },
        {
            key: 'actions',
            render: (user: IUser) => {
                return (
                    <div className='table-row-actions'>
                        <Button icon={<DeleteOutlined/>} color="clear" onClick={() => openDeleteUserModal({ onOk:onDeleteUser, user })} style={{marginRight:9}}>
                            Delete
                        </Button>
                        <Button icon={<ArrowRightOutlined/>} iconPosition="right" onClick={() => BrowserRouter.push(BrowserRoutes.getUsersById(user.id))}>
                            Details
                        </Button>
                    </div>
                )
            }
        }
    ]
}